<template lang="pug">
section
  header.d-flex.row.flex-row.align-items-end.mb-3
    .col-8
      h1.m-0
        i Administración de usuarios
    .col-2.text-right
      router-link.btn.btn-secondary.py-2.px-4(to="create")
        i.icon.icon-plus.icon--1x.mr-2
        strong Nuevo usuario
    .col-2.text-right
      router-link.btn.btn-secondary.py-2.px-4(to="masivo")
        i.icon.icon-upload.icon--1x.mr-2
        strong Carga masiva
  section
    .d-flex.flex-row.align-items-start.mt-4.ad_border1-secondary.rounded-xl.py-1.w-50.ml-auto
      .col
        b-form-input.border-0(v-model='filter', placeholder='Buscar por nombre, usuario, perfil, e-mail o rut')
      .col-auto
        b-button.py-1(:disabled='!filter', @click="filter = ''", title='Limpiar filtro')
          i.icon.icon--1x.icon-cross

    .d-flex.row.flex-row.align-items-start.mt-4
      .col-12
        .card.p-0.ad_bg-gray.rounded-xl
          .card-body
            b-table.table-simple.no-border(
              show-empty
              stacked="md"
              :items='users',
              :fields="fields",
              :current-page="currentPage",
              :per-page="perPage",
              :filter="filter",
              @filtered="onFiltered")
              template(slot='leader', slot-scope='row')
                .div(v-if="row.item.leader")
                  i.icon.icon-checkmark
                .div(v-else)
              
              template(slot='isDeleted', slot-scope='row')
                | {{row.item.isDeleted ? 'No' : 'Si'}}
              template(slot='edit', slot-scope='row')
                router-link(:to="{path:'/administracion/'+row.item.id+'/edit'}" title="Editar usuario" append)
                  i.icon.icon-pencil3
              template(slot='view', slot-scope='row')
                router-link(:to="{path:'/administracion/'+row.item.id+'/view'}" title="Ver usuario" append)
                  i.icon.icon-eye
              template(slot='reopen', slot-scope='row')
                  .div(v-if="row.item.canPlan == 1")
                    router-link(to="#" title="Reabrir Planificación Semanal" append)
                      i.icon.icon-unlocked(@click="modalReopenPlan(row.item, row.index, $event.target)")
                  .div(v-else)
                    i.icon-disabled.icon-unlocked
              template(slot='delete', slot-scope='row')
                .div(v-if="!row.item.isDeleted")
                  router-link(to="#" title="Desactivar usuario" append)
                    i.icon.icon-bin(@click="deleteUser(row.item, row.index, $event.target, true)")
                .div(v-else)
                  i.icon-disabled.icon-bin
              template(slot='activate', slot-scope='row')
                .div(v-if="row.item.isDeleted")
                  router-link(to="#" title="Activar usuario" append)
                    i.icon.icon-user-check(@click="deleteUser(row.item, row.index, $event.target, false)")
                .div(v-else)
                  i.icon-disabled.icon-user-check
            .row.mt-5
              .col-auto
                p Total de usuarios:
                  |  {{ totalRows }}
              .col-auto.ml-auto
                b-pagination(
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0")

  b-modal(:id='infoModal.id', :title='infoModal.title', modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    p {{ infoModal.content }}
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
        b-button.px-4(size="lg", variant="danger", @click="$bvModal.hide(infoModal.id)")
          | No
        b-button.px-4(size="lg", variant="success", @click="handleOk()")
          | {{ infoModal.buttonName }}
    </template>

  b-modal(:id='reopenModal.id', :title='reopenModal.title', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    p {{ reopenModal.content }}
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
        b-button.px-4(size="lg", variant="danger", @click="$bvModal.hide(reopenModal.id)")
          | No
        b-button.px-4(size="lg", variant="success", @click="Reabrir()")
          | Reabrir
    </template>
  
</template>

<script>
import { mapActions } from 'vuex'
import administracionUsuariosDetailVue from './administracion-usuarios-detail.vue';
export default {
  name: 'AdministracionUsuarios',
  components: {},
  data () {
    return {
      users: null,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      fields: [
        { key: 'name', label: 'Nombre', sortable: true, sortDirection: 'desc'},
        { key: 'username', label: 'Usuario', sortable: true, class: 'text-center'},
        { key: 'profilename', label: 'Perfil', sortable: true},
        { key: 'email', label: 'Correo', sortable: true},
        { key: 'rut', label: 'Rut', sortable: true},
        { key: 'leader', label: 'Lider', sortable: true},
        { key: 'boss', label: 'Jefe', sortable: true},
        { key: 'isDeleted', label: 'Activo', sortable: true},
        { key: 'edit', label: '' , class: 'text-right'},
        { key: 'view', label: '' , class: 'text-right'},
        { key: 'reopen', label: '' , class: 'text-right'},
        { key: 'delete', label: '' , class: 'text-right'},
        { key: 'activate', label: '' , class: 'text-right'}
      ],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
        buttonName: '',
        action: ''
      },
      reopenModal: {
        id: 'reopen-modal',
        title: 'Reabrir Planificacion',
        content: ''
      }
    }
  },
  methods: {
    ...mapActions('user', [
      'getUsers',
      'activateUser',
    ]),
    ...mapActions('plan', [
      'reopenCurrentWeekPlan'
    ]),
    onlyUsersActives(items) {
      return items.filter(u => u.isDeleted === false)
    },
    listUsers() {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.getUsers().then(usersData => {
        // vm.users = vm.onlyUsersActives(usersData)
        vm.users = usersData
        this.totalRows = vm.users.length
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    onFiltered(filteredItems) {
      this.totalRows = this.onlyUsersActives(filteredItems).length
      this.currentPage = 1
    },
    deleteUser(item, index, button, action) {
      const vm = this
      let name = item.username ? item.username : item.name;
      let actionName = action ? 'Eliminar' : 'Activar';
      vm.$root.$emit('bv::show::modal', vm.infoModal.id, button)
      const modal = vm.$el.querySelector('.modal')
      modal.style.left = '25%'
      modal.style.right = '25%'
      modal.style.top = '25%'
      modal.style.height = '240px'
      vm.infoModal.title = `${actionName} usuario`
      vm.infoModal.content = `¿Está seguro de ${actionName} el usuario "${name}"?`
      vm.infoModal.userId = item.id
      vm.infoModal.buttonName = actionName
      vm.infoModal.action = action
    },
    handleOk() {
      const vm = this
      const data = {id: vm.infoModal.userId, isDeleted: vm.infoModal.action}
      vm.activateUser(data).then(user => {
        vm.$bvModal.hide(vm.infoModal.id)
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Usuario eliminado',
          closeable: true,
          duration: 5000
        })
        vm.listUsers()
      }).catch(e => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    modalReopenPlan(item, index, button) {
      const vm = this
      vm.$root.$emit('bv::show::modal', vm.reopenModal.id, button)
      const modal = vm.$el.querySelector('.modal')
      modal.style.left = '25%'
      modal.style.right = '25%'
      modal.style.top = '25%'
      modal.style.height = '240px'
      vm.reopenModal.content = `¿Está seguro de reabrir el plan de la semana actual del usuario "${item.username}"?`
      vm.reopenModal.userId = item.id
    },
    Reabrir() {
      const vm = this
      const data = {user: vm.reopenModal.userId}
      vm.reopenCurrentWeekPlan(data).then( result => {
        vm.$bvModal.hide(vm.reopenModal.id)
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Plan Semanal Abierto',
          closeable: true,
          duration: 5000
        })
      }).catch(e => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  mounted() {
    const vm = this
    vm.listUsers()
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-usuarios.vue